<div class="container">
  <div class="center">
    <div class="stateActual" *ngIf="!changeToStatePF">
      <span
        class="fa-layers fa-fw fa-4x"
        style="
          background: rgb(174, 219, 106);
          color: #003e51;
          border-radius: 5px;
          height: 75px;
          width: 75px;
          cursor: pointer;
        "
      >
        <em class="fas fa-envelope"></em>
        <span
          class="fa-layers-counter"
          style="background: Tomato; margin-top: 6px"
          >{{ actualState }}</span
        >
      </span>
    </div>
    <div class="contentCenterStates" *ngIf="!changeToStatePF">
      <div class="state mr-1" *ngFor="let state of statesAvailable">
        <span
          class="fa-layers fa-fw fa-4x"
          (click)="onClick(state)"
          style="color: #003e51; cursor: pointer"
        >
          <em class="fas fa-envelope"></em>
          <span class="fa-layers-counter" style="background: Tomato">{{
            state.estado
          }}</span>
        </span>
      </div>
    </div>
  </div>

  <div
    class="contentCenterStates"
    *ngIf="changeToStatePF && !isAnalistaTramitante"
  >
    <ng-container *appPermsRoles="[roles.RHOMOLOG, roles.REVISOR]">
      <div class="flotado mr-1" *ngFor="let state of statesAvailableForPF">
        <ng-container
          *ngIf="
            ((actualState != 'CR' && state.estado == 'CR') ||
              state.estado == 'CA') &&
            actualState != 'CA'
          "
        >
          <span
            class="fa-layers fa-fw fa-4x"
            (click)="onClick(state)"
            style="color: #003e51; cursor: pointer"
          >
            <em class="fas fa-envelope"></em>
            <span class="fa-layers-counter" style="background: Tomato">{{
              state.estado
            }}</span>
          </span>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <div class="contentCenterStates" *ngIf="changeToStatePF">
    <ng-container
      *appPermsRoles="[roles.AAVANZA, roles.ABASICO, roles.ANALISTA]"
    >
      <div
        class="flotado mr-1"
        *ngFor="let state of statesAvailableAnalistaForPF"
      >
        <ng-container
          *ngIf="
            actualState == 'AN' ||
            actualState == 'PA' ||
            (actualState == 'CA' && isAnalistaTramitante)
          "
        >
          <span
            class="fa-layers fa-fw fa-4x"
            (click)="onClick(state)"
            style="color: #003e51; cursor: pointer"
          >
            <em class="fas fa-envelope"></em>
            <span class="fa-layers-counter" style="background: Tomato">{{
              state.estado
            }}</span>
          </span>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <div
    class="contentCenterStates"
    *ngIf="changeToStatePF && isAnalistaTramitante"
  >
    <div
      class="flotado mr-1"
      *ngFor="let state of statesAvailableAnalistaTramitanteForPF"
    >
      <ng-container *ngIf="actualState == 'PF'">
        <span
          class="fa-layers fa-fw fa-4x"
          (click)="onClick(state)"
          style="color: #003e51; cursor: pointer"
        >
          <em class="fas fa-envelope"></em>
          <span class="fa-layers-counter" style="background: Tomato">{{
            state.estado
          }}</span>
        </span>
      </ng-container>
    </div>
  </div>
</div>
<app-modal-form
  #modal
  (sendForm)="sendForm($event)"
  [title]="titleModal"
  locatorClass="locatorClassModal"
  [confirmMessage]="
    '<strong>¿Está seguro que quiere cambiarlo de estado?</strong>'
  "
></app-modal-form>
<swal
  #confirmSwal
  html="<strong>¿Está seguro que quiere cambiarlo de estado?</strong>"
  icon="warning"
  [showCancelButton]="true"
  [swalOptions]="{
    confirmButtonText: 'Aceptar',
    cancelButtonText: 'Cancelar',
    allowEscapeKey: false,
    allowOutsideClick: false
  }"
  [focusCancel]="true"
>
</swal>
<swal
  #formUpdatedWithoutSaveSwal
  html="<strong>Debes guardar las modificaciones antes de cambiar de estado</strong>"
  icon="warning"
  [showCancelButton]="false"
  [swalOptions]="{
    confirmButtonText: 'Aceptar',
    allowEscapeKey: false,
    allowOutsideClick: false
  }"
  [focusCancel]="false"
>
</swal>
